/* eslint camelcase: "off" */
import React from 'react'
import { ApolloProvider } from 'react-apollo'
import PropTypes from 'prop-types'
import 'react-dates/lib/css/_datepicker.css'
import './override.css'
import Tab from './Tab'
import { client } from '../shared/ApolloClient'

const Layout = (props) => {
  const {
    smartbiz_user,
    require_additional_cash_flow_analysis,
    business_id,
    loan_id,
    product_id,
    interim_calculation,
    loan_amount,
    loan_interest_rate,
    loan_term,
    living_expense,
    officer_comp_addback,
    other_taxes,
    federal_taxes,
    months_remaining_cutoff,
    years,
    showDebtSchedule,
    isEditAllowed,
    isCustomerService,
    calculationsBaseUrl,
    calculationsToken,
    depositsAnalysisUi = false
  } = props
  return (
    <ApolloProvider client={client}>
      <Tab
        smartbizUser={smartbiz_user}
        requireAdditionalCashflowAnalysis={require_additional_cash_flow_analysis}
        isEditAllowed={isEditAllowed}
        loanId={loan_id}
        productId={product_id}
        businessId={business_id}
        years={years}
        officerCompAddback={officer_comp_addback}
        interimCalculation={interim_calculation}
        federalTaxes={federal_taxes}
        otherTaxes={other_taxes}
        loanTerm={loan_term}
        loanAmount={loan_amount}
        livingExpense={living_expense}
        loanInterestRate={parseFloat(loan_interest_rate)}
        showDebtSchedule={showDebtSchedule}
        monthsRemainingCutoff={months_remaining_cutoff}
        isCustomerService={isCustomerService}
        depositsAnalysisUi={depositsAnalysisUi}
        calculationsBaseUrl={calculationsBaseUrl}
        calculationsToken={calculationsToken}
      />
    </ApolloProvider>
  )
}

Layout.propTypes = {
  loan_id:     PropTypes.number.isRequired,
  business_id: PropTypes.number.isRequired
}

export default Layout
